// studioScheduleSaga.ts

import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { API } from 'src/api';

import {
  updateScheduleData, updateScheduleDataFailure, updateScheduleDataSuccess,
} from '../reducers/currentStudioSlice';

import { errorHandler } from './common';

const apiMethods: Record<string, any> = {
  'update': API.patch,
  'delete': API.delete,
  'add': API.post,
};

function* handleScheduleUpdateSaga (action: any) {
  try {
    // @ts-ignore
    const { params, currentId } = action.payload;
    // @ts-ignore
    const token = yield select(state => state.auth.token);

    yield all(
      params.map((param: any) =>
        all(
          param.values.map((value: any) =>
            call<any>(
              apiMethods[param.operation],
              `/studios/${currentId}/${param.tag}`,

              param.operation === 'delete' ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                data: value,
              }
                :
                value,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
          )
        )
      )
    );
    yield put(updateScheduleDataSuccess());
  } catch (error) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield handleScheduleUpdateSaga(action);
      },
      *callback () {
        yield put(updateScheduleDataFailure());
      },
    });
  }
}

export function* studioScheduleSaga () {
  // @ts-ignore
  yield takeEvery(updateScheduleData().type, handleScheduleUpdateSaga);
}
